/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_REPORT_JOBS,
  GET_REPORT_JOB,
  SET_REPORT_JOB,
  CLEAR_REPORT_JOB,
  GET_REPORT_JOB_META,
  SET_SUBJECT_LIST_PARSE
} from 'src/redux/actions/reportJobActions';

const initialState = {
  // Report Status list
  jobs: null,
  total: 0,
  page: 1,
  pageSize: 10,
  // The job the wizard or detail view is working on
  job: null,
  // Result of the last subject-list parse: detected headers, row counts,
  // per-row issues. Shown under the step 1 preview.
  parseResult: null,
  // Document types, jurisdiction rules, upload limits and whether the
  // generation agent is connected yet.
  meta: null
};

const reportJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_JOBS: {
      const { rows, total, page, pageSize } = action.payload;
      return produce(state, (draft) => {
        draft.jobs = rows;
        draft.total = total;
        draft.page = page;
        draft.pageSize = pageSize;
      });
    }

    case GET_REPORT_JOB:
    case SET_REPORT_JOB: {
      const job = action.payload;
      return produce(state, (draft) => {
        draft.job = job;
      });
    }

    case SET_SUBJECT_LIST_PARSE: {
      const parseResult = action.payload;
      return produce(state, (draft) => {
        draft.parseResult = parseResult;
      });
    }

    case GET_REPORT_JOB_META: {
      const meta = action.payload;
      return produce(state, (draft) => {
        draft.meta = meta;
      });
    }

    case CLEAR_REPORT_JOB: {
      return produce(state, (draft) => {
        draft.job = null;
        draft.parseResult = null;
      });
    }

    default:
      return state;
  }
};

export default reportJobReducer;
